import PermissionPrincipal from './hooks/PermissionPrincipal';
import Loading from '../../shared/Loading/Loading';
import Toolbar from './components/Toolbar';
import Permissions from './components/Permissions';

const PermissionsView = (props) => {  
  const vm = PermissionPrincipal(props)

  return vm.loading ? (
    <div className="flex justify-center py-10">
      <Loading size="28" colorBase='gray-100' colorAccent='personalized' double={true} bold="8" />
    </div>
  ) : (
    <>
      <Toolbar
        roles={vm.roles}
        confirm={vm.confirm}
        loading={vm.loading}
        isEditor={vm.isEditor}
        roleName={vm.roleName}
        selectedRole={vm.selectedRole}
        openRoleModal={vm.openRoleModal}
        roleModalMode={vm.roleModalMode}
        setRole={vm.setRole}
        askDelete={vm.askDelete}
        changeSave={vm.changeSave}
        handleSaveRole={vm.handleSaveRole}
        handleEditRole={vm.handleEditRole}
        handleCreateRole={vm.handleCreateRole}
        closeDeleteModal={vm.closeDeleteModal}
        setPermissionsSave={vm.setPermissionsSave}
        handleConfirmDelete={vm.handleConfirmDelete}
        handleRoleFormChange={vm.handleRoleFormChange}
        handleCloseRoleModal={vm.handleCloseRoleModal}
      />
      <Permissions
        matriz={vm.matriz}
        isEditor={vm.isEditor}
        selectedRole={vm.selectedRole}
        permissionsRoles={vm.permissionsRoles}
        permissions={vm.permissions}
        setPermissionsSave={vm.setPermissionsSave}
      />
    </>
  );
};

export default PermissionsView;
